import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getDeepLink } from "@edp-store/selectors/depp-link.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { combineLatest, Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class EdpFuncionaGuard implements CanActivate {
    constructor(private store: Store<IAppState>, private router: Router) {}

    canActivate(): Observable<UrlTree | boolean> {
        return combineLatest([this.store.select(getContract), this.store.select(getDeepLink)]).pipe(
            switchMap(([contract]) => {
                if (!!contract && (contract.HasPack || contract.HasServiceFunciona || contract.HasServiceFuncionaCA)) {
                    return of(true);
                }
                const path = !!contract ? `/energia/${contract.ContractId}/inicio` : "/energia/inicio";
                return of(this.router.parseUrl(path));
            })
        );
    }
}
